import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { EmailsClient } from '../../api.service';

@Injectable({
  providedIn: 'root',
})
export class EmailSizeLimitService {
  private sizeLimitMb$: Observable<number>;

  constructor(private emailsClient: EmailsClient) {}

  getSizeLimitMb(): Observable<number> {
    if (!this.sizeLimitMb$) {
      this.sizeLimitMb$ = this.emailsClient.getSizeLimit().pipe(
        map(response => response.sizeLimitMb),
        shareReplay(1),
        // Plain shareReplay caches an error just as permanently as a success, so one
        // failed lookup (e.g. a transient 502) would otherwise poison every later call
        // for the rest of the page session. Drop the cache on error so the next call retries.
        catchError(error => {
          this.sizeLimitMb$ = undefined;
          return throwError(error);
        }),
      );
    }
    return this.sizeLimitMb$;
  }
}
